import TopicOne from "../deposits-and-withdrawals-contents/TopicOne";

const DepositsAndWithdrawalsContentOne = () => {
  return (
    <>
      <TopicOne />

      <div className="how__work__trading">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="content-left">
                <h3>Verify Your Payment Methods</h3>
                <p>
                  Ensure all requested documents are submitted and approved to
                  enable faster processing.
                </p>
                <h3>Use the Same Method You Deposited With</h3>
                <p>
                  Withdraw up to your deposit amount through the original
                  payment method for instant alignment.
                </p>
                <h3>Match Account Names Exactly</h3>
                <p>
                  Your withdrawal destination must match your Pips account name
                  to avoid compliance-related holds.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="thumb-right">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/trading/deposits_and_withdrawals/deposit_n_withdrawals_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DepositsAndWithdrawalsContentOne;
